// Constants
import Constants from 'constants.js';
// Dispatcher
import Dispatcher from 'core/Dispatcher';
// Service
import ControlTowerService from 'services/ControlTowerService';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';
//Entities
import ControlTowerObject from 'core/entities/ControlTowerEntities/ControlTowerObject';

class ControlTowerAction {
    getData(params) {
        Dispatcher.dispatch({
            actionType: Constants.CONTROL_TOWER_GET_DATA_START,
            value: params
        });

        ControlTowerService.getStats(params).then(stats => {
            Dispatcher.dispatch({
                actionType: Constants.CONTROL_TOWER_GET_STATS,
                value: stats
            });
            ControlTowerService.getData(params).then(data => {
                Dispatcher.dispatch({
                    actionType: Constants.CONTROL_TOWER_GET_DATA,
                    value: new ControlTowerObject(data)
                });
            }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    changeAction(action, ids, siteId, clickAllItems, bot, status, params) {
        return ControlTowerService.changeAction(action, ids, bot, status, params).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.CONTROL_TOWER_CHANGE_STATUS,
                value: {
                    action,
                    newData: data.success,
                    siteId,
                    clickAllItems,
                    params
                }
            });
            return true;
        }, err => {
            console.log(err);
            return false;
        });
    }
}

export default new ControlTowerAction();
